import React, { useEffect, useState } from 'react';
import VideoPlayer from '../../../../Components/VideoPlayer/VideoPlayer';
import { NavLink, useNavigate, useSearchParams } from 'react-router-dom';

import "./Lesson.css"
import axios from 'axios';
import { BASE_URL } from '../../../../utils/Constants';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import { faPause } from '@fortawesome/free-solid-svg-icons'
import CongraEffect from '../../../../Components/CongraEffect';
const Lessson = () => {


    // function play(id:any, videoId:any) {
    //     let RunningVideo :any = null
    //     var x :any= document.getElementById(`${id}`);
    //     if (x.style.display === "none") {
    //       x.style.display = "block";
    //     } else {
    //       x.style.display = "none";
    //     }
    //     if (RunningVideo !== null) {
    //       RunningVideo.pauseVideo();
    //     }
    //     RunningVideo = new YT.Player(id, {
    //       height: '390',
    //       width: '640',
    //       videoId: videoId,
    //       events: {
    //         onReady: onPlayerReady,
           
    //       },
    //     });
       
    //   }
      
    //   function onPlayerReady(event:any) {
    //     // console.log(event.target)
    //     event.target.playVideo();
    //   }
      
  
      




    const [searchParams, setSearchParams] = useSearchParams();
    let id = searchParams.get("id")
    let module_id = searchParams.get("module_id")
    const [activeLesson, setActiveLesson] = useState<any>()
    const [videoPlaying , setVideoPlaying] = useState<any>();
    const [module, setModule] = useState<any>();
    const[PlayBack , setPlayback] = useState<any>(1);
    const [congratulation , setCongratulation] = useState(false)
     const handleFulScreen = (e: any) => {
    let target = e.target;

    let action = target.classList[1];

    document.getElementById("resdad")?.requestFullscreen();
    // if (action === 'fa-expand') {
    // //   target.className = "fas fa-compress"
    // } else {
    // //   target.className = "fas fa-expand"
    //   document.exitFullscreen();

    // }

  }

    useEffect(() => {
        Swal.showLoading();
        axios.post(`${BASE_URL}/course/getmodule.php`, { id, module_id }).then((res: any) => {

            if (res.data.data) {
                let findLesson = res.data.data.find((l: any) => l.lesson_id == id);
                setActiveLesson(findLesson)
                setModule({
                    crs_name: res.data.data[0].crs_name,
                    course_id: res.data.data[0].course_id,
                    module_id: res.data.data[0].module_id,

                    module_name: res.data.data[0].module_name,
                    lessons: res.data.data
                })
            Swal.close();
            }

        }).catch((error)=>{
            Swal.fire("Error" , error.response.data.msg , "error").then(() => {
                navigate("/")
            })
        })
    }, [])
    const navigate = useNavigate();
    const handleCompleteLesson = (lesson_id: any, course_id: any) => {
        axios.post(`${BASE_URL}/course/completelesson.php`, { lesson_id, course_id }).then((res: any) => {

            setActiveLesson((prevState: any) => ({ ...prevState, status: "c" }));
            
            let tempLessons = [...module.lessons]
            let findLesson = tempLessons.find((l)=>l.id == lesson_id);
            findLesson.status = "c";
            module.lessons = tempLessons
            setModule({...module})
            setCongratulation(true)

            setTimeout(() => {
                setCongratulation(false)
            }, 5000);
        }).catch((err: any) => {

        })
    }
    const handleUnCompleteLesson = (lesson_id: any, course_id: any) => {
        axios.post(`${BASE_URL}/course/uncompletelesson.php`, { lesson_id, course_id }).then((res: any) => {
            let tempLessons = [...module.lessons]
            let findLesson = tempLessons.find((l)=>l.id == lesson_id);
            findLesson.status = "";
            module.lessons = tempLessons
            setModule({...module})
            setCongratulation(false)

            setActiveLesson((prevState: any) => ({ ...prevState, status: "" }))
        }).catch((err: any) => {

        })
    }

    const handleLessonClick = (lesson:any)=>{
        setCongratulation(false)
        axios.post(`${BASE_URL}/course/setlastlesson.php`, { lesson_id : lesson.lesson_id }).then((res: any) => {

            setActiveLesson((prevState: any) => ({ ...prevState }))
        }).catch((err: any) => {

        })
        setActiveLesson(lesson)
        setVideoPlaying(false)
    }
    console.log(module?.lessons)
    const changeVideoStatus = (status :any) =>{
        if(status == "play"){

            // setVideoPlaying(true)
        }else {
            // setVideoPlaying(false)

        }
    }
    return (
        <div id="myvideosection">
            {congratulation? ( <CongraEffect />) :null}
           
            <section >
                <div className="text-center w-100 mb-5">

                    <h2 className="title "> <NavLink to={`/course?id=${module?.course_id}`}>{module?.crs_name}</NavLink>  / {module?.module_name}</h2>
                </div>
                <div className="container">
                    <div id="main-Video">
              
                        
                   
            {videoPlaying ? ( <VideoPlayer video_path={activeLesson?.video_path} playBack = {PlayBack} changeVideoStatus ={(status:any)=>{changeVideoStatus(status)}}></VideoPlayer>) : 
            (

                        <div className="wrap" onClick={()=>{
                            setVideoPlaying(true); 
                            //  play(`player${activeLesson?.lesson_id}` , "e1To0CkT6fU")
                            }}>
                            <div className="d-flex align-items-center px-2 mycardx" style={{ justifyContent: "center" ,cursor:"pointer"}}>
                                <div id={`player${activeLesson?.lesson_id}`} style={{ display: "none" }}></div>
                                <div id="cplayer'.$video->id.'" className="card bg-dark text-white">
                                    <img className="vidImg card-img" loading="lazy" width="705" height="396" style={{ width: "100%", height: "100%" }} src={`${BASE_URL}/images/${activeLesson?.lesson_image_path}`}
                                        alt="Video Default Image" />
                                    <div className="card-img-overlay" >
                                        <span className="playIcon">▶</span>
                                    </div>
                                </div>
                            </div>                           
                        </div>
            )
            }
                        {/* </div>
                            </div> */}
                        <div className="text-center ">
                            {activeLesson?.status == "c" ? (
                                <button className="btn btn-success " onClick={() => { handleUnCompleteLesson(activeLesson.lesson_id, activeLesson.course_id) }}>Completed great job</button>
                            ) : (
                                <button className="btn btn-primary " onClick={() => { handleCompleteLesson(activeLesson.lesson_id, activeLesson.course_id) }}> Mark as complete</button>
                            )}


                        </div>
                    </div>
                    <div className="playlistBx">
                        <div className="header" style={{ backgroundColor: "#536863" }}>
                            <div className="row d-flex justify-content-between">

                                <span className="col-6 col-sm-3 AllLessons"> {module?.module_name} </span>
                                <span className="col-6 d-none d-md-block AllLessons"> {module?.lessons?.length} Lessons</span>
                            </div>
                        </div>
                        <ul className="playlist active" id="playlist">
                            {module?.lessons?.map((lesson: any, index: any) => {
                                return (

                                    <li li-index={lesson.lesson_id} key={index} className={activeLesson.lesson_id == lesson.lesson_id ? "playing" : ""} onClick={() => {handleLessonClick(lesson)}}>
                                        <div className="row ">
                                       
                                            <span> {activeLesson.lesson_id == lesson.lesson_id ? (<FontAwesomeIcon icon={faPause} />) : (<FontAwesomeIcon icon={faPlay} />)} &nbsp; {index + 1} - {lesson.lesson_name}</span>
                                        </div>
                                        <video className="vid_1" src="" style={{ display: 'none' }} title="Name"></video>
                                        <span id="vid_1" className="duration"></span>
                                    </li>
                                )
                            })}

                        </ul>
                    </div>
                </div>
            </section>
        </div>
    )
}



export default Lessson